import { AUTHENTICATED } from '../core/action-types'

export const setUser = (user) => {
  return { type: AUTHENTICATED, payload: user }
}
